import React from 'react';
import ManagementSwapRequests from '../../modules/exam/ManagementSwapRequests';

const ExamSchedulerPage = () => {
    return (
        <div className="container-fluid">
            <ManagementSwapRequests />
        </div>
    );
};

export default ExamSchedulerPage;